import { useCreateTag } from "@/hooks/api";
import { useState } from "react";
import type { GroupBase, SelectInstance } from "react-select";
import CreatableSelect from "react-select/creatable";

type OptionType = {
  id: number;
  name: string;
};

interface TransactionTagProps {
  options?: OptionType[];
  value?: OptionType[];
  onChange: (value: OptionType[]) => void;
  isLoading?: boolean;
  transactionId?: number;
  inputRef?: React.Ref<SelectInstance<OptionType, true, GroupBase<OptionType>>>;
  isCategoryLoading?: boolean;
}

export const TransactionTag = ({
  options: initialOptions = [],
  value,
  onChange,
  isLoading,
  inputRef,
}: TransactionTagProps) => {
  const createTagMutation = useCreateTag();
  const [options, setOptions] = useState<OptionType[]>(initialOptions);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  const handleOnCreate = async (inputValue: string) => {
    createTagMutation.mutate(inputValue, {
      onSuccess: (newTag) => {
        // Update local options
        setOptions((prevOptions) => [...prevOptions, newTag]);

        // Update parent component state with the new tag
        const updatedValue = [...(value || []), newTag];
        onChange(updatedValue);
      },
    });
  };

  return (
    <CreatableSelect
      ref={inputRef}
      isMulti
      options={options}
      value={value}
      onChange={(newValue) => onChange(newValue as OptionType[])}
      onCreateOption={handleOnCreate}
      getOptionLabel={(option: OptionType) => option.name}
      getOptionValue={(option: OptionType) => String(option.id)}
      placeholder="Select or create tags..."
    />
  );
};
